const images = [
    "https://plaza.one/img/backs/44.gif",
    "https://plaza.one/img/backs/72.gif",
    "https://plaza.one/img/backs/53.gif",
    "https://plaza.one/img/backs/58.gif",
    "https://plaza.one/img/backs/02.gif",
    "https://plaza.one/img/backs/12.gif",
    "https://plaza.one/img/backs/77.gif",
    "https://plaza.one/img/backs/39.gif",
    "https://plaza.one/img/backs/45.gif",
    "https://plaza.one/img/backs/46.gif",
    "https://plaza.one/img/backs/48.gif",
    "https://plaza.one/img/backs/02.gif"


  ];

  export default images;